// Public API for Facade
// None :)
"use strict";
var type_1 = require("./type");
exports.Type = type_1.Type;
var async_1 = require("./async");
exports.EventEmitter = async_1.EventEmitter;
//# sourceMappingURL=facade.js.map


//////////////////
// WEBPACK FOOTER
// ./${exlibris_product}/npm_modules/August2022-PROD/prima/node_modules/ng-metadata/src/facade/facade.js
// module id = 493
// module chunks = 6